import React from 'react'
import { columns } from './static'
import { useNavigate } from 'react-router-dom'
import { Text, VStack } from '@chakra-ui/react'
import useFetch from '../../../../hook/useFetch'
import { colors } from '../../../../theme/colors'
import { getStoreReels } from '../../../../apis/store'
import DataTable from '../../../../commons/DataTable/DataTable'

const StoreReels = ({ store }) => {
    const navigate = useNavigate()

    const { data, isLoading } = useFetch({
        name: `getStoreReels_${store._id}`,
        service: getStoreReels,
        id: store._id,
        params: { limit: 0 }
    })

    return (
        <VStack alignItems={'flex-start'} space='2' borderWidth={1} p='4' bg={colors.light} borderRadius='lg' borderColor={colors.border}>
            <Text fontSize={'md'} fontWeight='600'>Store Reels ({data?.total})</Text>
            <DataTable tableData={{ columns: columns(navigate), data, pagination: false, isLoading }} pagination={false} />
        </VStack>
    )
}

export default StoreReels